import { API_BASE_URL } from '../../config/api';

interface EspWebInstallButtonOptions {
  manifest: string;
  baudRate: number;
  installHeadlineFast?: string;
  trackFirmware?: {
    model?: string;
    fromFirmware?: string;
    toFirmware?: string;
  };
}

function reportWebFlasherUpdate(payload: {
  serial: string;
  model?: string;
  fromFirmware?: string;
  toFirmware?: string;
}) {
  if (!payload.serial || !payload.toFirmware) return;
  fetch(`${API_BASE_URL}/devices/firmware-update-events`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({
      serial: payload.serial,
      model: payload.model || '',
      fromFirmware: payload.fromFirmware || '',
      toFirmware: payload.toFirmware,
      method: 'web_flasher',
      status: 'success',
      source: 'web_flasher',
    }),
  }).catch((error) => {
    console.warn('Failed to record web flasher update:', error);
  });
}

export function configureEspWebInstallButton(
  installButton: HTMLElement,
  options: EspWebInstallButtonOptions,
): void {
  installButton.setAttribute('manifest', options.manifest);
  installButton.setAttribute('data-baud-rate', options.baudRate.toString());
  installButton.setAttribute('data-post-flash-identify', 'true');

  if (options.installHeadlineFast) {
    installButton.setAttribute('data-install-headline-fast', options.installHeadlineFast);
  }

  if (options.trackFirmware) {
    installButton.addEventListener('device-identify', ((event: Event) => {
      const detail = (event as CustomEvent<{
        serial?: string;
        model?: string;
        versions?: { firmware?: string };
      }>).detail;
      const serial = detail?.serial;
      const toFirmware = detail?.versions?.firmware || options.trackFirmware?.toFirmware;
      if (!serial || !toFirmware) return;
      reportWebFlasherUpdate({
        serial,
        model: options.trackFirmware?.model || detail?.model,
        fromFirmware: options.trackFirmware?.fromFirmware,
        toFirmware,
      });
    }) as EventListener);
  }
}
